import styled from 'styled-components';

const Wrapper = styled.div`
  margin: -65px -90px 50px;

  @media only screen and (max-width: 870px) {
    margin: -35px -5px 20px;
  }
`;

export default Wrapper;